import { PropsWithChildren } from "react";
import { useDrawerContext } from "./DrawerContextProvider";

export const DrawerItemLabel = ({ children }: PropsWithChildren) => {
  const { isDrawerOpen } = useDrawerContext();

  return isDrawerOpen && children;
};
